module.exports = __webpack_public_path__ + "img/animal approach (1).e0d97336.png";